export default __webpack_public_path__ + "images/d4608a97f617cea98e4748f06a937180.svg";